<div class="flex flex-col gap-2">
  @if (label()) {
    <label class="truncate" [ngClass]="smallLabel() ? 'text-sm' : ''" [for]="id()">
      {{ label() | transloco }}
      @if (isRequired()) {
        <span class="text-red" [ngClass]="smallLabel() ? 'text-sm' : ''">*</span>
      }
    </label>
  }

  @if (isReadOnly()) {
    <input
      pInputText
      [value]="form.get(fieldName())?.value | date: readOnlyFormat() : '' : userLanguage()"
      [disabled]="true"
      class="w-full"
    />
  } @else {
    <p-datePicker
      [id]="id()"
      [attr.data-testid]="id() + '-input'"
      [formControlName]="fieldName()"
      [ngClass]="{'p-invalid': form.get(fieldName())?.invalid && form.get(fieldName())?.touched}"
      [showButtonBar]="true"
      [view]="view()"
      [dateFormat]="dateFormat()"
      [showIcon]="true"
      [showClear]="showClear()"
      (onSelect)="handleSelect($event)"
      appendTo="body"
    ></p-datePicker>
  }
</div>
